<template>
  <div
    class="image-container"
    :id="content.key"
  >
    <el-image
      class="image"
      :id="`${content.key}-1`"
      :src="content.collectionCover.img"
      :preview-src-list="content.content.map(item => item.url)"
      :style="{
        width: canSetWidth ? content.collectionCover.width : ''
      }"
    ></el-image>
    <p
      class="image-title"
      :id="`${content.key}-2`"
      :style="{
        fontFamily: content.collectionCover.titleStyle.fontFamily || '',
        fontSize: (content.collectionCover.titleStyle.fontSize + 'px') || '',
        lineHeight: (content.collectionCover.titleStyle.lineHeight + 'px') || '',
        textIndent: (typeof content.titleStyle.textIndent === 'string') ? content.titleStyle.textIndent :
          (typeof content.titleStyle.textIndent === 'number') ? (content.titleStyle.textIndent + 'rem') : '',
        fontWeight: content.collectionCover.titleStyle.fontWeight || '',
        textDecoration: content.collectionCover.titleStyle.underline === 1 ? 'underline' : '',
        fontStyle: content.collectionCover.titleStyle.fontItalic === 1 ? 'italic' : '',
        textAlign: content.collectionCover.titleStyle.textAlign || '',
        color: content.collectionCover.titleStyle.color || '',
        backgroundColor: content.collectionCover.titleStyle.backgroundColor || '',
      }"
    >{{ content.collectionCover.title }}</p>
  </div>
</template>

<script>
/*
图片集合的封面样式
*/
export default {
  name: "imageUnitCollection",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
    canSetWidth: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style lang="scss" scoped>
.image-container {
  width: 100%;

  .image{
    width: 100%;
    height: auto;
    display: block;
    margin: 0 auto 10px;
  }

  .image-title{
    display: block;
    margin-bottom: 10px;
    width: 100%;
    text-align: center;
    font-size: 16px;
    color: #00a8ac;
  }
}
</style>